import HomeScreen from '../../components/HomeScreen';

const HomeSection = ({ onConfigureKit, onBrowseProducts, onGetGuidance, onNavigate }) => {
  return (
    <div className="space-y-16">
      <HomeScreen
        onConfigureKit={onConfigureKit}
        onBrowseProducts={onBrowseProducts}
        onGetGuidance={onGetGuidance}
        onNavigate={onNavigate}
      />
    </div>
  );
};

export default HomeSection;
